import { render, staticRenderFns } from "./NPSFeedbackPage.vue?vue&type=template&id=4c4dc8db&scoped=true"
import script from "./NPSFeedbackPage.vue?vue&type=script&lang=js"
export * from "./NPSFeedbackPage.vue?vue&type=script&lang=js"
import style0 from "./NPSFeedbackPage.vue?vue&type=style&index=0&id=4c4dc8db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4dc8db",
  null
  
)

export default component.exports